(() => {
  const resolveState = (kinds) => {
    const hasIncluded = kinds.includes('included');
    const hasStandard = kinds.includes('standard');

    if (hasIncluded && !hasStandard) return 'included';
    if (hasIncluded && hasStandard) return 'mixed';
    return 'standard';
  };

  globalThis.CGCartShipping = { resolveState };

  if (typeof HTMLElement === 'undefined' || typeof customElements === 'undefined') return;

  class CGShippingProgress extends HTMLElement {
    connectedCallback() {
      const kinds = Array.from(this.querySelectorAll('[data-cg-shipping-item]')).map(
        (item) => item.dataset.cgShippingItem
      );
      const state = resolveState(kinds);
      const bar = this.querySelector('[data-cg-shipping-bar]');
      const fill = this.querySelector('[data-cg-shipping-fill]');
      const note = this.querySelector('[data-cg-shipping-note]');

      this.dataset.shippingState = state;

      if (state === 'included') {
        bar.hidden = false;
        fill.style.width = '100%';
        note.textContent = this.dataset.includedMessage;
        note.classList.add('cg-ship__note--done');
      } else if (state === 'mixed') {
        bar.hidden = true;
        note.textContent = this.dataset.mixedMessage;
        note.classList.remove('cg-ship__note--done');
      } else {
        bar.hidden = false;
        fill.style.width = `${this.dataset.standardPercentage}%`;
      }
    }
  }

  if (!customElements.get('cg-shipping-progress')) {
    customElements.define('cg-shipping-progress', CGShippingProgress);
  }
})();

